import {
    FaCogs,
    FaPlug,
    FaProjectDiagram,
    FaTachometerAlt,
    FaChartLine,
    FaChalkboardTeacher,
} from "react-icons/fa";

export const featuresData = [
    {
        id: 1,
        icon: <FaCogs />,
        title: "Test Automation Frameworks",
        des: "Design and development of scalable automation frameworks using Playwright, Cypress, Selenium, and Appium, focused on maintainability, reliability, and long-term adoption."
    },
    {
        id: 2,
        icon: <FaPlug />,
        title: "API & Integration Testing",
        des: "End-to-end API testing strategies covering REST services, contract validation, and edge cases to detect defects early in the development lifecycle."
    },
    {
        id: 3,
        icon: <FaProjectDiagram />,
        title: "CI/CD Quality Gates",
        des: "Integration of automated tests into CI/CD pipelines (Jenkins, GitHub Actions, Azure DevOps) to enforce quality gates and enable fast, safe releases."
    },
    {
        id: 4,
        icon: <FaTachometerAlt />,
        title: "Performance Testing",
        des: "Performance and load testing using K6 and JMeter, with monitoring and analysis through Grafana to validate scalability and system stability."
    },
    {
        id: 5,
        icon: <FaChartLine />,
        title: "Quality Strategy & Reporting",
        des: "Definition of test strategies, risk-based testing, and clear reporting to support informed release decisions and continuous quality improvement."
    },
    {
        id: 6,
        icon: <FaChalkboardTeacher />,
        title: "Teaching & Mentoring",
        des: "University-level teaching and mentoring in QA automation, helping engineers adopt best practices in testing, automation, and quality engineering."
    }
];
